import { FC } from 'react';
import clsx from 'clsx';
import { useAlert, Props } from './useAlert';
import styles from './Alert.module.css';

export const Alert: FC<Props> = (props) => {
  const { children, theme } = useAlert(props);

  return (
    <div
      className={clsx(
        styles.alert,
        theme === 'info' && styles.info,
        theme === 'success' && styles.success,
        theme === 'warning' && styles.warning,
        theme === 'error' && styles.error
      )}>

      <div>{children}</div>
    </div>);

};